<div class="sign-in-title">
  <div class="custom-bold">
    Sign in to
  </div>
  <div class="custom-light">
    Vallourec Upload
  </div>
</div>
<div class="sign-in-vallourec">
<div class="vallourec_account">
<div class="custom-text">
  If you have a Vallourec account:
</div>
<button class="vlr-cta-btn vlr-icon-btn vlr-w100-btn" (click)="signIn()" style="display: inline-flex; align-items: center; justify-content: center; gap: 12px; white-space: nowrap;">
  <img height="24" alt="Logo Vallourec"
       src="../../assets/img/logo_vallourec.svg" style="filter: brightness(0) invert(1);">
  <span>
    Sign in with Vallourec Account
  </span>
</button>
</div>
<div class="or">
</div>
<div class="customer_account">
<div class="custom-text">
  If you have been invited:<br>
</div>

<div>
  <div>
    <label for="username" class="label">Email</label>
    <input id="username" type="email" [formControl]="username" placeholder="Enter your email" class="input">
  </div>
  <div>
    <label for="password" class="label">Password</label>
    <input id="password" type="password" [formControl]="password" (input)="password.setValue(password.value?.trim())" placeholder="Enter your password" class="input">
  </div>
  <button class="vlr-text-link-btn" (click)="forgotPassword()" style="padding-left: 0;">Forgot password?</button>
  <div style="height: 24px">
    <span class="error" *ngIf="errorMessage" [@showAnimation]>
    {{errorMessage}}
  </span>
  </div>

</div>

<button (click)="signInExternal()" class="vlr-cta-btn vlr-w100-btn">
  <span>
    Sign In
  </span>
</button>
</div>
</div>
